<div class="prize-tag-filter">
  <div class="section-header">
    <div class="section-title">
      <h4>Tags</h4>
      <i
        class="pi pi-info-circle tooltip-info-icon"
        pTooltip="Include tags the item must have, and exclude tags it must not have."
        tooltipPosition="top"
      ></i>
    </div>
  </div>

  <div class="tag-rule" *ngIf="form" [formGroup]="form">
    <div class="p-field">
      <label class="rule-label">Include tags</label>
      <p-multiSelect
        [options]="tagOptions"
        optionLabel="name"
        optionValue="_id"
        formControlName="includeTagRefs"
        display="chip"
        [filter]="true"
        filterBy="name"
        placeholder="Select tags to include"
        [style]="{ width: '100%' }"
      ></p-multiSelect>
    </div>

    <div class="p-field-checkbox">
      <p-checkbox formControlName="excludeAllOtherTags" [binary]="true" inputId="excludeAllOtherTags"></p-checkbox>
      <label for="excludeAllOtherTags">Exclude any other tag the item might have</label>
    </div>

    <div class="p-field" *ngIf="!excludeAllOtherTagsControl.value">
      <label class="rule-label">Exclude tags</label>
      <p-multiSelect
        [options]="tagOptions"
        optionLabel="name"
        optionValue="_id"
        formControlName="excludeTagRefs"
        display="chip"
        [filter]="true"
        filterBy="name"
        placeholder="Select tags to exclude"
        [style]="{ width: '100%' }"
      ></p-multiSelect>
    </div>
  </div>
</div>
